import { graphql } from "react-relay";

export const autopilotEventHistoryFragments = {
  event: graphql`
    fragment AutopilotEventHistory_event on Event
    @argumentDefinitions(calendarId: { type: "String!" }) {
      eventAutopilotHistory {
        __typename
        ... on EventAutopilotHistory {
          status
          actions {
            actionType
            actionString
            actionInfo
            timestamp
          }
        }
        ... on GraphEntityError {
          message
        }
      }
      eventKey {
        externalEventId
      }
      title
      autopilotEventStatus(calendarId: $calendarId) {
        __typename
        ... on AutopilotEventStatus {
          status
        }
      }
      startTime {
        dateOrDateTime
      }
      featureStatesForOrganizer {
        __typename
        ... on FeatureStates {
          mixedFreemiumOrgUIState {
            autopilotPaused
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};
